export const NineSlicePresets = {
  Default: (scene: Phaser.Scene) => {
    return new Phaser.GameObjects.NineSlice(
      scene,
      0,
      0,
      "Button1",
      undefined,
      32,
      32,
      7,
      7,
      7,
      7,
    );
  },
  DamagedSign: (scene: Phaser.Scene, index: number) =>
    new Phaser.GameObjects.NineSlice(
      scene,
      0,
      0,
      "DamagedSigns",
      `DamagedSign${index}`,
      124,
      124,
      40,
      40,
      40,
      40,
    ),
};
